import { render } from "./BatchCollectionTray.vue?vue&type=template&id=0090fffe&scoped=true&ts=true"
import script from "./BatchCollectionTray.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchCollectionTray.vue?vue&type=script&setup=true&lang=ts"

import "./BatchCollectionTray.vue?vue&type=style&index=0&id=0090fffe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0090fffe"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/BatchCollectionTray.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0090fffe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0090fffe', __exports__)) {
    api.reload('0090fffe', __exports__)
  }
  
  module.hot.accept("./BatchCollectionTray.vue?vue&type=template&id=0090fffe&scoped=true&ts=true", () => {
    api.rerender('0090fffe', render)
  })

}


export default __exports__